module.exports = __webpack_public_path__ + "img/boleto.cf0ff6ba.svg";